import { useContext, useState } from "react";
import DataTable from "react-data-table-component";

import { LabourerContext } from "../contexts/LabourerContext";
import TableLoader from "./TableLoader";
import SectionHeader from "./SectionHeader";

import useAllocations from "../hooks/useAllocations";

import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

const EmployeeAllocationList = ({ onAllocationClicked, onRequestLeaveClicked }) => {
  const { labourer } = useContext(LabourerContext);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);

  const { data, isLoading } = useAllocations({ labourerId: labourer?._id, page, perPage });

  const allocations = data?.allocations;
  const allocationCount = data?.count;

  const allocationColumns = [
    {
      name: 'Project',
      selector: row => row.project.name
    },
    {
      name: 'Start Date',
      selector: row => row.startDate,
      format: row => formatDateToSydneyTimeZone(row.startDate)
    },
    {
      name: 'End Date',
      selector: row => row.endDate,
      format: row => formatDateToSydneyTimeZone(row.endDate)
    }
  ];

  const handlePageChange = page => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  return (
    <div className='border border-ase-blue rounded-lg pb-1'>
      <SectionHeader title='My Allocations' actionsLeft={
        <button
          onClick={onRequestLeaveClicked}
          className='px-2 py-1 bg-white rounded-md text-ase-blue font-semibold text-xs'
        >
          Request leave
        </button>}
      />

      <DataTable
        columns={allocationColumns}
        data={allocations}
        striped
        highlightOnHover
        pagination
        paginationServer
        pointerOnHover
        onRowClicked={onAllocationClicked}
        progressPending={isLoading}
        progressComponent={<TableLoader />}
        paginationTotalRows={allocationCount}
        paginationRowsPerPageOptions={[5, 10, 20]}
        paginationPerPage={perPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />
    </div>
  )
}

export default EmployeeAllocationList;
